import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import jsonExport from "jsonexport/dist";
import { fillDownRows } from "../../../utils/exportsUtils";

import DateFnsUtils from "@date-io/date-fns";
import { addMonths, format, startOfMonth } from "date-fns";

import { API, graphqlOperation } from "aws-amplify";
import {
  getOutboundShipmentActivity,
  searchInventorysActivity,
} from "../../../graphql/report-queries";
import { productByAccountByActiveByName } from "../../../graphql/queries";

import { Box, Card, Grid, TextField as FilterField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";

import {
  Button,
  Datagrid,
  DateField,
  downloadCSV,
  ListContextProvider,
  NumberField,
  required,
  SimpleForm,
  TextField,
  Title,
  TopToolbar,
  useList,
  useListContext,
  useNotify,
} from "react-admin";

import { ExportIcon } from "../../../components/common/iconography";
import { BackButton } from "../../../components/common/BackButton";
import { ForceTitle } from "../../../components/common/ForceTitle";
import { HelpButton } from "../../../components/common/HelpButton";
import { MonthRangeSlider } from "../../../components/common/MonthRangeSlider";
import { Pagination } from "../../../components/Pagination";
import { AccountDropDown } from "../../../components/common/AccountDropDown";
import { fetchAllPages, logError } from "../../../utils/appUtils";
import { ShipmentLineItemStatus } from "../../../utils/constants";
import { deepRedirect, getBackPath } from "../../../utils/utils";

const exporter = (inventories) => {
  debugger;
  const inventoriesForExport = inventories.map((inventory) => {
    let totalOutbound = 0;

    const inventoryForExport = {
      inventoryId: inventory.id,
      productCode: inventory.productCode,
      productName: inventory.productName,
      lotNumber: inventory.lotNumber,
      inboundShipmentId: inventory.inboundShipmentId,
      inboundPoNumber: inventory.poNumber,
      receivedDate: inventory.receivedAt,
      inventoryUOM: inventory.inventoryUOM,
      status: inventory.status,
      quantityReceived: `${inventory.quantityReceived}`,
      quantityCommitted: `${inventory.quantityCommitted}`,
      quantityOnHand: `${inventory.quantityOnHand}`,
    };

    if (inventory.shipmentLineItems?.items.length > 0) {
      inventoryForExport.outbounds = inventory.shipmentLineItems?.items.map(
        (itm) => {
          const outbound = {
            quantityShipped: `${itm.totalQuantityToPick}`,
            ShipmentId: itm.outboundShipmentId,
            poNumber: itm.outboundShipment.poNumber,
            status: itm.status,
            shippedDateTime: itm.outboundShipment.departureDateTime,
          };
          totalOutbound +=
            itm.status === ShipmentLineItemStatus.SHIPPED
              ? itm.totalQuantityToPick
              : 0;
          return outbound;
        },
      );
    }

    inventoryForExport.totalQuantityOutbound = `${totalOutbound}`;
    totalOutbound = 0;

    return inventoryForExport;
  });

  jsonExport(
    fillDownRows(inventoriesForExport),
    {
      rename: [
        // "Customer", "Product Code", "Product", "Inventory Qty", "UOM"
      ],
    },
    (err, csv) => {
      downloadCSV(csv, "ProductActivityReport"); // download as 'ProductActivityReport.csv` file
    },
  );
};

const ListActions = (props) => {
  const {
    finalData,
    accountId,
    handleAccountChange,
    yearMonth,
    setYearMonth,
    monthRange,
    setMonthRange,
    productId,
    setProductId,
    productOptions,
    productsLoading,
    getInventoryActivity,
  } = props;

  const selectedProduct =
    productOptions.find((product) => product.id === productId) || null;

  return (
    <Box mt={-4} mb={1}>
      <TopToolbar>
        <HelpButton />
        <Button
          label="Export"
          disabled={finalData?.length === 0}
          onClick={() => exporter(finalData)}
        >
          <ExportIcon />
        </Button>
        <BackButton basePath="/reports" />
      </TopToolbar>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Grid container spacing={1}>
          <Grid item xs={12} md={3}>
            <AccountDropDown
              source="accountId"
              label="Account"
              onAccountChange={handleAccountChange}
              validate={required()}
              allowEmpty={false}
              helperText={false}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <Autocomplete
              options={productOptions}
              getOptionLabel={(option) =>
                option
                  ? `${option.productCode || ""}${
                      option.name ? ` - ${option.name}` : ""
                    }`
                  : ""
              }
              value={selectedProduct}
              loading={productsLoading}
              disabled={!accountId}
              onChange={(event, value) => {
                setProductId(value?.id || "");
              }}
              renderInput={(params) => (
                <FilterField
                  {...params}
                  id="product"
                  label="Product"
                  variant="outlined"
                  margin="dense"
                  fullWidth
                  required
                  helperText={false}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={2} xl={1}>
            <DatePicker
              label="Year / Month"
              variant="inline"
              inputVariant="outlined"
              margin="dense"
              fullWidth
              disableToolbar
              disableFuture
              autoOk
              required
              openTo="year"
              views={["year", "month"]}
              format="MM/yyyy"
              minDate={new Date(window.appUser?.reloadYard.createdAt)}
              maxDate={new Date()}
              value={yearMonth}
              onChange={setYearMonth}
            />
          </Grid>
          <Grid item xs={12} md={2} xl={3}>
            <Box mt={-1.5}>
              <MonthRangeSlider
                monthRange={monthRange}
                setMonthRange={setMonthRange}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={1} container justifyContent="flex-end">
            <Box mt={1.5}>
              <Button
                label="Run"
                variant="contained"
                color="default"
                alwaysOn
                onClick={getInventoryActivity}
                disabled={!accountId || !productId || !yearMonth}
              />
            </Box>
          </Grid>
        </Grid>
      </MuiPickersUtilsProvider>
    </Box>
  );
};

// /reportProductActivity
export const ProductActivityReport = (props) => {
  const notify = useNotify();
  const reloadYardId = window.appUser?.reloadYardId
    ? window.appUser.reloadYardId
    : props.history?.location?.state?.reloadYardId;

  const [accountId, setAccountId] = useState("");
  const [yearMonth, setYearMonth] = useState(null);
  const [monthRange, setMonthRange] = useState(1);
  const [productId, setProductId] = useState("");

  const [productOptions, setProductOptions] = useState([]);
  const [productsLoading, setProductsLoading] = useState(false);

  const [finalData, setFinalData] = useState([]);
  const [activityData, setActivityData] = useState([]);
  const [currentTotals, setCurrentTotals] = useState({
    onHand: 0,
    available: 0,
    committed: 0,
  });
  const [loading, setLoading] = useState(false);

  const loadProductsForAccount = async (selectedAccountId) => {
    if (!selectedAccountId) {
      setProductOptions([]);
      setProductId("");
      return;
    }

    try {
      setProductsLoading(true);
      // A limit is a page size, not a total: an account with more products
      // than one page would otherwise be missing rows from the dropdown.
      const productData = await fetchAllPages({
        query: productByAccountByActiveByName,
        variables: {
          accountId: selectedAccountId,
          activeName: { beginsWith: { active: "true" } },
        },
        responseKey: "productByAccountByActiveByName",
        pageLimit: 500,
        label: "ProductActivityReport:products",
      });
      setProductOptions(productData);
    } catch (error) {
      logError("ProductActivityReport:loadProductsForAccount", error, notify);
      setProductOptions([]);
    } finally {
      setProductsLoading(false);
    }
  };

  const handleAccountChange = (selectedAccount) => {
    const selectedId = selectedAccount?.id || "";
    setAccountId(selectedId);
    setProductId("");
    setProductOptions([]);
    if (selectedId) {
      loadProductsForAccount(selectedId);
    }
  };

  const getInventoryActivity = async () => {
    try {
      setLoading(true);
      debugger;
      const startDate = format(startOfMonth(yearMonth), "yyyy-MM");
      const endDate = format(
        startOfMonth(addMonths(yearMonth, monthRange - 1)),
        "yyyy-MM",
      );
      const limit = 1000;

      const searchInput = {
        sort: { field: "receivedAt", direction: "asc" },
        filter: {
          reloadYardId: { eq: reloadYardId },
          and: [
            { receivedAt: { gte: `${startDate}` } },
            { receivedAt: { lte: `${endDate}` } },
          ],
        },
        limit,
      };
      if (accountId) {
        searchInput.filter.accountId = { eq: `${accountId}` };
      }
      if (productId) {
        searchInput.filter.productId = { eq: `${productId}` };
      }

      let inventorys = [];
      let nextToken = true;
      while (nextToken) {
        const input =
          nextToken === true ? searchInput : { ...searchInput, nextToken };
        const result = await API.graphql(
          graphqlOperation(searchInventorysActivity, input),
        );
        inventorys.push(...result.data.searchInventorys.items);
        if (result.data.searchInventorys.items.length < limit) break;
        nextToken = result.data.searchInventorys.nextToken;
      }
      // inventorys = inventorys.filter(itm => itm.shipmentLineItems.items.length > 0 );

      const outboundIdMap = {};
      const promiseList = [];
      inventorys.forEach((inv) => {
        inv.shipmentLineItems.items.forEach((itm) => {
          if (!outboundIdMap[itm.outboundShipmentId]) {
            outboundIdMap[itm.outboundShipmentId] = true;
            promiseList.push(
              API.graphql(
                graphqlOperation(getOutboundShipmentActivity, {
                  id: itm.outboundShipmentId,
                }),
              ),
            );
          }
        });
      });

      const results = await Promise.all(promiseList);
      results.forEach((res) => {
        outboundIdMap[res.data.getOutboundShipment.id] =
          res.data.getOutboundShipment;
      });

      inventorys.forEach((inv) => {
        inv.shipmentLineItems.items.forEach((itm) => {
          itm.outboundShipment = outboundIdMap[itm.outboundShipmentId];
        });
      });

      const activityRecords = [];
      let totalOnHand = 0;
      let totalCommitted = 0;

      inventorys.forEach((inv) => {
        const inboundQuantity = inv.quantityReceived || 0;
        totalOnHand += inv.quantityOnHand || 0;
        totalCommitted += inv.quantityCommitted || 0;

        activityRecords.push({
          id: `${inv.id}-inbound`,
          date: inv.receivedAt,
          type: "Inbound",
          stockAction: inboundQuantity,
          poNumber: inv.poNumber || "",
          railCarNumber: inv.railCarNumber || inv.containerNumber || "",
          shipmentId: inv.inboundShipmentId || "",
        });

        inv.shipmentLineItems.items.forEach((itm) => {
          const outbound = itm.outboundShipment || {};
          const quantity = itm.totalQuantityToPick || 0;
          const date =
            outbound.departureDateTime ||
            outbound.arrivalDateTime ||
            inv.depletedAt ||
            null;

          activityRecords.push({
            id: `${inv.id}-${itm.id}`,
            date,
            type: "Outbound",
            stockAction: -quantity,
            poNumber: outbound.poNumber || "",
            railCarNumber: outbound.railCarNumber || "",
            shipmentId: itm.outboundShipmentId || "",
          });
        });
      });

      activityRecords.sort((a, b) => {
        if (!a.date && !b.date) return 0;
        if (!a.date) return 1;
        if (!b.date) return -1;
        return new Date(a.date) - new Date(b.date);
      });

      setActivityData(activityRecords);
      setCurrentTotals({
        onHand: totalOnHand,
        committed: totalCommitted,
        available: totalOnHand - totalCommitted,
      });
      setFinalData(inventorys);
    } catch (err) {
      logError("InventoryActivityList:getInventoryActivity", err, notify);
      setActivityData([]);
      setFinalData([]);
      setCurrentTotals({
        onHand: 0,
        available: 0,
        committed: 0,
      });
    } finally {
      setLoading(false);
    }
  };

  const fixedFilter = ""; // {"lowInventoryAlert": true};
  const defaultSort = { field: "receivedAt", order: "ASC" };
  const defaultPerPage = 25;

  const listContext = useList({
    ...props,
    data: activityData,
    ids: activityData.map(({ id }) => id),
    loading,
    loaded: !loading,
    filter: fixedFilter,
    sort: defaultSort,
    perPage: defaultPerPage,
  });

  return (
    <SimpleForm toolbar={false}>
      <ListContextProvider value={listContext}>
        <Title title={<ForceTitle title="Inventory Activity" />} />
        <ListActions
          {...props}
          finalData={finalData}
          accountId={accountId}
          handleAccountChange={handleAccountChange}
          yearMonth={yearMonth}
          setYearMonth={setYearMonth}
          monthRange={monthRange}
          setMonthRange={setMonthRange}
          productId={productId}
          setProductId={setProductId}
          productOptions={productOptions}
          productsLoading={productsLoading}
          getInventoryActivity={getInventoryActivity}
        />
        <Card>
          <ProductActivityGrid {...props} />
          <ActivityTotals totals={currentTotals} />
          <Pagination {...listContext} />
        </Card>
      </ListContextProvider>
    </SimpleForm>
  );
};

const ProductActivityGrid = (props) => {
  const history = useHistory();
  const backPath = getBackPath(props);
  const listContext = useListContext(props);
  listContext.basePath = "/inventories";
  listContext.resource = "inventories";

  const handleRowClick = (id, basePath, record) => {
    if (!record || !record.shipmentId) return;

    const isOutbound = record.type === "Outbound";
    const toPath = isOutbound
      ? `/outboundShipments/${record.shipmentId}`
      : `/inboundShipments/${record.shipmentId}`;

    deepRedirect(history, toPath, backPath, {});
  };

  return (
    <Datagrid rowClick={handleRowClick} {...listContext}>
      <DateField source="date" label="Date" />
      <TextField source="type" label="Type" />
      <NumberField source="stockAction" label="Stock Action" />
      <TextField source="poNumber" label="PO Number" />
      <TextField source="railCarNumber" label="Car/Trl No." />
    </Datagrid>
  );
};

const ActivityTotals = ({ totals }) => {
  if (!totals) return null;

  const { onHand, available, committed } = totals;

  return (
    <Grid container spacing={1} style={{ padding: 16 }}>
      <Grid item xs={12} md={3}>
        <strong>Current Totals</strong>
      </Grid>
      <Grid item xs={12} md={3}>
        On-Hand: {onHand}
      </Grid>
      <Grid item xs={12} md={3}>
        Committed: {committed}
      </Grid>
      <Grid item xs={12} md={3}>
        Available: {available}
      </Grid>
    </Grid>
  );
};
